<template>
  <div>
    <!-- CAMPAIGN CHART SECTION -->
    <section-page :title="chartSectionTitle">
      <template v-slot:right>
        <stats-campaigns-filter @applyFilter="handleFilter"/>
      </template>

      <app-loading-section :loading="chartIsLoading">
        <stats-campaigns-chart
          :chart="campaignChartData"
          :lead-chart-data="leadChartData"
          :contracted-chart-data="contractedChartData"
          :closed-chart-data="closedChartData"
        />
      </app-loading-section>
    </section-page>

    <!-- CAMPAIGN TABLE BREAKDOWN -->
    <section-page title="Breakdown By Campaign">
      <stats-campaigns-table :campaigns="campaignTableData" :is-loading="tableIsLoading"/>
    </section-page>
  </div>
</template>

<script>

import StatsCampaignsTable from "./components/StatsCampaignsTable.vue";
import StatsCampaignsChart from "./components/StatsCampaignsChart.vue";
import StatsCampaignsFilter from "./components/StatsCampaignsFilter.vue";
import utils from "../../services/utils";
import api from "../../api";
import CancelablePromise from "../../services/CancelablePromise";

export default {
  name: "StatsCampaignsTab",
  components: {StatsCampaignsFilter, StatsCampaignsChart, StatsCampaignsTable},
  data() {
    return {
      chartIsLoading: false,
      tableIsLoading: false,
      filterValues: {
        campaign_ids: [],
        start_at: null,
        end_at: null
      },
      reloadingCampaignTablePromise: null,
      campaignTableData: [],
      campaignChartData: {
        cost: 0,
        leads: 0,
        contracted: 0,
        closed: 0,
        projected_profit: 0,
        actual_profit: 0,
      },
      leadChartData: {
        labels: [],
        datasets: [{
          label: 'Leads',
          data: [],
          backgroundColor: [
            'rgb(255, 196, 0)',
            'rgb(30, 136, 229)',
            'rgb(242, 84, 48)',
            'rgb(76, 175, 80)',
            'rgb(198, 40, 40)',
          ],
          hoverOffset: 4,
          borderWidth: 4,
        }]
      },
      contractedChartData: {
        labels: [],
        datasets: [{
          label: 'Contracted',
          data: [],
          backgroundColor: [
            'rgb(30, 136, 229)',
            'rgb(76, 175, 80)',
            'rgb(198, 40, 40)',
          ],
          hoverOffset: 4,
          borderWidth: 4,
        }]
      },
      closedChartData: {
        labels: [],
        datasets: [{
          label: 'Closed',
          data: [],
          backgroundColor: [
            'rgb(30, 136, 229)',
            'rgb(76, 175, 80)',
            'rgb(198, 40, 40)',
          ],
          hoverOffset: 4,
          borderWidth: 4,
        }]
      },
    }
  },
  mounted() {
    // this.loadTableData()
  },
  computed: {
    chartSectionTitle() {
      return `Total Campaign Costs ${utils.formatCurrency(this.campaignChartData.cost)}`
    },
  },
  methods: {
    handleFilter(values) {
      this.filterValues.campaign_ids = values.campaignIds
      this.filterValues.start_at = values.timeframe.startAt
      this.filterValues.end_at = values.timeframe.endAt
      this.loadChartData()
      this.loadTableData()
    },
    loadChartData() {
      this.chartIsLoading = true
      return Promise.all([
        api.stats.getStatsCampaignChart(this.filterValues),
        api.stats.getStatsCampaignLeadChart(this.filterValues),
        api.stats.getStatsCampaignContractedChart(this.filterValues),
        api.stats.getStatsCampaignClosedChart(this.filterValues),
      ]).then(([chart, leads, contracted, closed]) => {
        this.campaignChartData = chart.data.data

        this.leadChartData.labels = leads.data.data.labels
        this.leadChartData.datasets[0].data = leads.data.data.values

        this.contractedChartData.labels = contracted.data.data.labels
        this.contractedChartData.datasets[0].data = contracted.data.data.values

        this.closedChartData.labels = closed.data.data.labels
        this.closedChartData.datasets[0].data = closed.data.data.values
      })
      .finally(() => this.chartIsLoading = false);
    },
    loadTableData() {
      this.tableIsLoading = true

      if (this.reloadingCampaignTablePromise) {
        this.reloadingCampaignTablePromise.cancel();
      }

      this.reloadingCampaignTablePromise = CancelablePromise(new Promise(async (resolve) => {
        this.campaignTableData = []
        for (let i=0; i < this.filterValues.campaign_ids.length; i++) {
          const payload = {
            campaign_id: this.filterValues.campaign_ids[i],
            // start_at: this.filterValues.start_at,
            // end_at: this.filterValues.end_at
          }

          await api.stats.getStatsCampaignSummary(payload)
            .then(res => {
              this.campaignTableData = [...this.campaignTableData, ...res.data]
            })
        }

        this.tableIsLoading = false
        resolve();
      }))
    },
  }
}
</script>

<style scoped lang="scss">

</style>
